import styled from 'styled-components';

export const Forms = styled.div`
  position: relative;
  .add-document {
    position: absolute;
    right: 0;
  }
  .icon {
    height: 14px;
    width: 14px;
    margin-right: 8px;
  }
  .add-judgement-add-pronoucing-style {
    padding: 10px 16px;
  }
`;
